module.exports = __webpack_public_path__ + "img/img_phone4_APP.fc1b0b0f.png";